import { Component, Input, OnInit, OnChanges } from '@angular/core';
import * as _ from 'lodash';
import { AssigneeHelperService } from '../../lib/tibAssignee/trackeritem.browse.assignee.helper';
import { UserService } from '../../../../core/services/core.user.service';
import { GfTranslateService } from '../../../../core/services/core.translate.service';

@Component({
  selector: 'assignees-filter',
  template: require('./assignees.filter.component.html')
})
export class AssigneesFilterComponent implements OnInit, OnChanges {
  @Input() filter: any;
  @Input() tracker: any;

  membersFilter: string = '';
  currentUser: any;
  membersList: any[] = [];
  private _assigneesHistoryList: any[] = [];
  private _fieldElements: any[] = [];
  private _specialFilters: any[] = [];
  private debouncedGetFilteredAssignees: Function;

  constructor(
    private assigneeHelper: AssigneeHelperService,
    private userService: UserService,
    private translateService: GfTranslateService
  ) {}

  ngOnInit() {
    this.currentUser = this.userService.session.getUser();
    this.debouncedGetFilteredAssignees = _.debounce(this.doSearch.bind(this), 250, { maxWait: 1000 });
    this.init();
  }

  ngOnChanges() {
    this.init();
  }

  getCurrentSelection(): string {
    if (this.filter.fieldData.length > 1) {
      return '(' + this.filter.fieldData.length + ')';
    } else if (this.filter.fieldData.length === 1) {
      return this.filter.fieldData[0].label;
    } else {
      return this.translateService.translate('No Selection');
    }
  }

  membersFilterUpdate() {
    if (this.membersFilter !== '') {
      this.debouncedGetFilteredAssignees(this.membersFilter, false);
    } else {
      this.setMembersList(_.get(this.filter, 'fieldElements', []), true);
    }
  }

  isAssignedTo(member: any): boolean {
    return !_.isEmpty(_.find(this.filter.fieldData, { id: member.id }));
  }

  setAssignee(event: Event, member: any) {
    event.preventDefault();
    event.stopPropagation();

    if (this.isAssignedTo(member)) {
      _.remove(this.filter.fieldData, { id: member.id });

      if (_.isEmpty(this.filter.fieldData)) {
        this.filter.fieldData.push(_.find(this._specialFilters, { id: 0 }));
      }
      return;
    }

    if (parseInt(member.id, 10) <= 100 || _.filter(this.filter.fieldData, (item) => parseInt(item.id, 10) <= 100).length > 0) {
      this._assigneesHistoryList = [];
      this.filter.fieldData = [];
    }

    this.filter.fieldData.push(member);
    this.addToAssigneesHistoryList();
  }

  // Private methods
  private addToAssigneesHistoryList() {
    this._assigneesHistoryList = _.unionBy(_.get(this.filter, 'fieldData', []), this._assigneesHistoryList, 'id');
  }

  private setMembersList(members: any[], includeCurAssigAndSpecialFilters: boolean = true) {
    let _membersList;

    if (includeCurAssigAndSpecialFilters) {
      const sortedAssignees = _.sortBy(this._assigneesHistoryList, 'label');
      const filteredMembers = _.filter(members, (member) => _.isEmpty(_.find(this._assigneesHistoryList, { id: member.id })) && member.id > 100);
      const sortedFilteredMembers = _.sortBy(filteredMembers, 'label');

      _membersList = _.union(this._specialFilters, sortedAssignees, sortedFilteredMembers);
    } else {
      _membersList = members;
    }

    this.membersList = _membersList;
  }

  private doSearch() {
    this.assigneeHelper.getFilteredAssignees(this.membersFilter, this.tracker.id)
      .then((data: any[]) => {
        const processedData = _.filter(data, (item: any) => parseInt(item.id, 10) > 100).map((item: any) => {
          item.label = item.firstname + ' ' + item.lastname;
          return item;
        });

        this.setMembersList(processedData, !this.membersFilter?.length);
      });
  }

  private init() {
    if (this._assigneesHistoryList?.length > 0) {
      this._assigneesHistoryList = _.cloneDeep(_.filter(_.get(this.filter, 'fieldData', []), (item) => parseInt(item.id, 10) > 100));
    }

    this._fieldElements = _.cloneDeep(_.filter(_.get(this.filter, 'fieldElements', []), (item) => parseInt(item.id, 10) > 100));
    this._specialFilters = _.cloneDeep(_.filter(_.get(this.filter, 'fieldElements', []), (item) => parseInt(item.id, 10) <= 100));

    this.setMembersList(this._fieldElements, true);
  }
}
